<div class="portal">
  <!-- First tab stop: past the rail and top bar to the page itself -->
  <a class="portal__skip" href="#main" (click)="skipToContent($event)">Skip to content</a>

  <!-- Mobile overlay behind the drawer -->
  @if (isSidebarOpen) {
    <div class="portal__scrim lg:hidden" (click)="closeSidebar(true)"></div>
  }

  <!-- Left rail — a drawer below lg, part of the layout from lg up -->
  <section
    #rail
    id="portal-rail"
    class="portal__rail"
    [class.is-open]="isSidebarOpen"
  >
    <app-sidebar
      [links]="sidebarLinks"
      [isMobileOpen]="isSidebarOpen"
      [nextSend]="nextSend"
      (nextSendOpen)="openNextSend()"
    ></app-sidebar>
  </section>

  <!-- Content column: top bar + routed views -->
  <div class="portal__main">
    <!-- Dims the page while the profile menu is open -->
    @if (isProfileOptionsOpen) {
      <div class="portal__dim"></div>
    }

    <div class="portal__top">
      <app-top-navbar
        [menuOpen]="isSidebarOpen"
        (menuClick)="toggleSidebar()"
        (profileOptionsChange)="handleProfileOptionsChange($event)"
      />
    </div>

    <main #view id="main" class="portal__view scrollbar-hover" tabindex="-1">
      <router-outlet></router-outlet>
    </main>
  </div>

  <!-- ⌘K / Ctrl+K and the top bar's search button; created fresh on each open -->
  @if (palette.paletteOpen()) {
    <app-command-palette [links]="sidebarLinks" />
  }

  <!-- "?" -->
  @if (palette.shortcutsOpen()) {
    <app-shortcuts-sheet />
  }
</div>
